export default "__VITE_ASSET__1UI3KNEU__"